import { render, staticRenderFns } from "./Drag.vue?vue&type=template&id=3dfbc960&scoped=true"
import script from "./Drag.vue?vue&type=script&lang=js"
export * from "./Drag.vue?vue&type=script&lang=js"
import style0 from "./Drag.vue?vue&type=style&index=0&id=3dfbc960&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfbc960",
  null
  
)

export default component.exports